export type TenantMode = "school" | "company";

export interface TenantAppConfig {
  mode: TenantMode;
  labels: {
    parent: string;
    school: string;
    child: string;
  };
  features: {
    canAddChild: boolean;
    showChildSection: boolean;
  };
}

export const TENANT_CONFIG_STORAGE_KEY = "tenant_app_config";

export const getDefaultTenantConfig = (mode: TenantMode = "school"): TenantAppConfig => {
  const isCompany = mode === "company";
  return {
    mode,
    labels: {
      parent: isCompany ? "Employee" : "Parent",
      school: isCompany ? "Company" : "School",
      child: isCompany ? "Dependent" : "Child",
    },
    features: {
      canAddChild: !isCompany,
      showChildSection: !isCompany,
    },
  };
};

export const normalizeTenantConfig = (config: any): TenantAppConfig => {
  if (!config || typeof config !== "object") {
    return getDefaultTenantConfig();
  }

  const mode: TenantMode = config.mode === "company" ? "company" : "school";
  const defaults = getDefaultTenantConfig(mode);

  return {
    mode,
    labels: {
      parent: config?.labels?.parent || defaults.labels.parent,
      school: config?.labels?.school || defaults.labels.school,
      child: config?.labels?.child || defaults.labels.child,
    },
    features: {
      canAddChild: typeof config?.features?.canAddChild === "boolean"
        ? config.features.canAddChild
        : defaults.features.canAddChild,
      showChildSection: typeof config?.features?.showChildSection === "boolean"
        ? config.features.showChildSection
        : defaults.features.showChildSection,
    },
  };
};

export const getTenantConfigFromStorage = (): TenantAppConfig => {
  try {
    const rawConfig = localStorage.getItem(TENANT_CONFIG_STORAGE_KEY);
    if (!rawConfig) {
      return getDefaultTenantConfig();
    }
    return normalizeTenantConfig(JSON.parse(rawConfig));
  } catch (error) {
    return getDefaultTenantConfig();
  }
};
